import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../services/http-client.service';
import { Router } from '@angular/router';
import { WebClientService } from '../../services/webclient-settings.service';
import { WebsiteThemeService } from '../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
/**
 * Highlight Component
 */
let HighlightComponent = class HighlightComponent {
    constructor(router, http, webSettingsService, sanitizer, themeService) {
        this.router = router;
        this.http = http;
        this.webSettingsService = webSettingsService;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.news = [];
        this.backColor = '';
        this.voucherColor = '';
        this.borderRadiusSmaller = '';
        this.slideConfig = {};
        this.slides = [];
        this.http.get('notifications').subscribe((result) => {
            this.news = result;
        });
        this.slideConfig = {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 3500,
            speed: 1000,
            infinite: true,
            responsive: [
                {
                    breakpoint: 1736,
                    settings: {
                        slidesToShow: 1,
                    }
                },
                {
                    breakpoint: 776,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        };
        this.themeService.getTheme().subscribe((data) => {
            this.backColor = this.themeService.getStyleAttribute('side_menu');
            this.voucherColor = this.themeService.getStyleAttribute('voucher_banner_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
        });
    }
    goToNews(event) {
    }
    openNews(id) {
        this.router.navigateByUrl('news/' + id);
    }
    customGo(event) {
    }
    slickInit(e) {
    }
    breakpoint(e) {
    }
    afterChange(e) {
    }
    beforeChange(e) {
    }
};
HighlightComponent.ctorParameters = () => [
    { type: Router },
    { type: SharedHttp },
    { type: WebClientService },
    { type: DomSanitizer },
    { type: WebsiteThemeService }
];
HighlightComponent = __decorate([
    Component({
        selector: 'ecd-highlight',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./highlight.component.html")).default
    })
], HighlightComponent);
export { HighlightComponent };
